import { Notification, Button, Text } from "@mantine/core";
import { IconBrandWhatsapp } from "@tabler/icons-react";
import { Colors, WhatsappSupportNumber } from "../../Lib/Data";
import { useContext } from "react";
import { AppContext } from "../../Pages/Wrapper";

export default function WhatsappChatBanner() {
  const context = useContext(AppContext);
  const theme = context?.theme ?? "light";
  return (
    <Notification
      withCloseButton={false}
      color={Colors.GreenPrimary}
      mt={40}
      bg={theme === "dark" ? Colors.BlackPrimary : Colors.White}
      title="More Support"
      styles={{
        title: {
          color: theme === "dark" ? Colors.GrayPrimary : Colors.BlackPrimary,
        },
      }}
    >
      <Text c={theme === "dark" ? Colors.White : Colors.GreenSecondary}>
        Speak with us on WhatsApp
      </Text>
      <Button
        mt={5}
        color={Colors.GreenPrimary}
        rightSection={<IconBrandWhatsapp size={18} />}
        onClick={() => {
          window.open(
            `https://wa.me/${WhatsappSupportNumber}?text=Hi!%20Please%20I%20need%20information%20concerning`
          );
        }}
      >
        Chat Now
      </Button>
    </Notification>
  );
}
